import { SOrganGroup } from '@lp/features/Scheduler/SchedulerSurgeons/types';
import { SchedulerSurgeons } from '@lp/features/Scheduler';
import {
  useLiSSchedulerData,
  useLiSSchedulerMutationActions,
  useLiSSchedulerServices,
  useLiSShiftChange,
  useLiSUnblockShift,
  useLiSWorkdaySync,
} from '@lp/features/Scheduler/SchedulerSurgeons/hooks';

type SchedulerLiverSurgeonsProps = {
  readonly?: boolean;
  showSettings?: boolean;
};

export const SchedulerLiverSurgeons = ({ readonly, showSettings }: SchedulerLiverSurgeonsProps) => {
  return (
    <SchedulerSurgeons
      organGroup={SOrganGroup.Liver}
      settingsPath="/schedule/s-li/settings"
      disableSettings={!showSettings}
      readonly={readonly}
      useSSchedulerData={useLiSSchedulerData}
      useSSchedulerMutationActions={useLiSSchedulerMutationActions}
      useSSchedulerServices={useLiSSchedulerServices}
      useSShiftChange={useLiSShiftChange}
      useSUnblockShift={useLiSUnblockShift}
      useSWorkdaySync={useLiSWorkdaySync}
    />
  );
};
